// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"5bfd7705","15":"40dc1ee3","37":"8b5e4009","453":"9094bb9a","556":"0eb6507f","680":"77147c8e","723":"a17f6426","843":"5ba8ac27","892":"ee4923d5","907":"10cdc1d0","908":"0881b8d9","971":"81d65449","973":"1cfe9898"}[chunkId] + ".chunk.js";
};